import { IconContent } from '../style';

const ExpandMore = () => (
  <IconContent fill='currentColor' viewBox='0 0 24 24'>
    <path d='M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z' />
  </IconContent>
);

export default ExpandMore;
